import { render, staticRenderFns } from "./LiveAccountContactClientAndClientUserView.vue?vue&type=template&id=504b7ded&scoped=true"
import script from "./LiveAccountContactClientAndClientUserView.vue?vue&type=script&lang=js"
export * from "./LiveAccountContactClientAndClientUserView.vue?vue&type=script&lang=js"
import style0 from "./LiveAccountContactClientAndClientUserView.vue?vue&type=style&index=0&id=504b7ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b7ded",
  null
  
)

export default component.exports